const MainIconSection = (props) => {

    const { itemArray } = props

    return (
        <section className="main-sections">

            {itemArray.map((item, index) => {
                return (
                    <section key={index} className="main-section">
                        <a href={item.link} data-discover="true" className="main-link">
                            {(item.icon) ? <span className="main-section-icon-wrap"><i className={item.icon} /></span> : <></>}
                            {(item.title) ? <label className="main-section-label">{item.title}</label> : <></>}
                            {(item.description) ? <label className="main-section-aux-label">{item.description}</label> : <></>}
                        </a>
                    </section>
                )
            })}

        </section>
    )

}

export default MainIconSection
